const WIZARD_DOCUMENT_TYPE = {
  LEASE_ADDENDUM: 'LEASE_ADDENDUM',
  CONDITION_REPORT: 'CONDITION_REPORT_TEMPLATE',
};

export const { LEASE_ADDENDUM } = WIZARD_DOCUMENT_TYPE;

export default WIZARD_DOCUMENT_TYPE;
